import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreAlertComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-alert/mapfre-alert.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserDataService } from '../../../../../_services/data-services/user-data.service';
import { PhoneFormatter } from '../../../../../_helpers/_formatters/phone-formatter';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { PolicyDataService } from '../../../../../_services/data-services/policy-data.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreAlertComponent, MapfreButtonComponent],
  selector: 'app-manage-contact',
  templateUrl: './manage-contact.component.html',
  styleUrls: ['./manage-contact.component.scss'],
})
export class ManageContactComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  noPhone = false;
  isAcmic: boolean;
  userDetails: any;
  email: string;
  phoneList: any = [];
  primaryPhone: { type: ''; number: '' };
  otherPhones: any = [];
  otherPhonesLength: number;
  listOfPhones: number;
  phoneTypes = ['mobile', 'home', 'work'];
  hidePhoneNumbersBlock: boolean;
  existAS400Policy: boolean;
  existGWPolicy: boolean;

  constructor(
    private router: Router,
    private userDataService: UserDataService,
    private phoneFormatter: PhoneFormatter,
    private acmicService: AcmicService,
    private policyDataService: PolicyDataService
  ) {
    this.hidePhoneNumbersBlock = false;
    this.existAS400Policy = false;
    this.existGWPolicy = false;
  }

  getThePhoneObject(phoneList, phoneType) {
    return phoneList.find(
      (phone) => phone.type.toLowerCase() === phoneType && phone.number !== ''
    );
  }
  orderPhoneList(phoneList) {
    const orderPhoneList = [];
    this.phoneTypes.forEach((phoneType) => {
      const phone = this.getThePhoneObject(phoneList, phoneType);
      if (phone) {
        orderPhoneList.push(phone);
      }
    });
    return orderPhoneList;
  }
  checkPrimaryPhone(phoneList) {
    this.listOfPhones = 0;
    this.primaryPhone = null;
    this.otherPhones = [];
    const otherPhonesWithoutOrder = [];
    phoneList.forEach((phone) => {
      phone.type = phone.type.toLowerCase() === 'cell' ? 'Mobile' : phone.type;
      if (phone.number !== '') {
        phone.number = this.phoneFormatter.format(phone.number);
        this.listOfPhones++;
        if (phone.primary) {
          this.primaryPhone = { type: phone.type, number: phone.number };
        } else {
          otherPhonesWithoutOrder.push(phone);
        }
      }
    });
    this.otherPhones = this.orderPhoneList(otherPhonesWithoutOrder);
    this.otherPhonesLength = this.otherPhones?.length;

  }
  getPolicyData() {
    this.policyDataService.$policyDetails.pipe(takeUntil(this.destroy$)).subscribe((policyResponse) => {
      if (policyResponse?.length) {
        this.hidePhoneNumbersBlock =
          policyResponse[0] &&
          policyResponse[0].policynumber.policyNumber.length === 6;

        this.existGWPolicy = policyResponse.some(policy => policy.policynumber?.policyNumber.length === 10
          && policy.company?.companyName !== "ACIC" && policy.company?.companyName !== "TW")
        this.existAS400Policy = policyResponse.some(policy =>
          policy.policynumber?.policyNumber.length === 6)
      }
    });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.detectStateCode();
    this.userDataService.$userData.pipe(takeUntil(this.destroy$)).subscribe((user) => {
      if (user && user.userDetails) {
        this.userDetails = user.userDetails;
        this.email = this.userDetails.email && this.userDetails.email.address;
        this.phoneList = this.userDetails.phoneList;
        if (this.phoneList?.length) {
          this.checkPrimaryPhone(this.phoneList);
        }
      }
    });
    this.getPolicyData();
  }

  gotoEditContact() {
    this.router.navigate(['profile', 'edit-contact']);
  }

  private detectStateCode(): void {
    this.isAcmic = this.acmicService.isACMIC();
  }
}
